/**
 * @file
 * @author dailin01
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import OutlinedDown from 'acud-icon/lib/icons/OutlinedDown';
import classNames from 'classnames';
import DropdownButton from './dropdown-button';
import { RcDropdown } from './rc-dropdown';
import { tuple } from '../_util/type';
import { cloneElement } from '../_util/reactNode';
import { ConfigContext } from '../config-provider';
import Select from '../select';
import Cascader from '../cascader';
import Menu from '../menu';
const PlacementTypes = tuple('bottomLeft', 'bottomCenter', 'bottomRight', 'topLeft', 'topCenter', 'topRight', 'rightTop', 'rightCenter', 'rightBottom', 'leftTop', 'leftCenter', 'leftBottom');
const Dropdown = props => {
    const { menu, 
    // Dropdown本身配置
    label, image, labelIcon, prefixCls: customizePrefixCls, disabled, trigger = ['hover'], 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    direction, visible, children, getPopupContainer } = props, rest = __rest(props, ["menu", "label", "image", "labelIcon", "prefixCls", "disabled", "trigger", "direction", "visible", "children", "getPopupContainer"]);
    const { getPrefixCls, getPopupContainer: getCxtPopupContainer } = React.useContext(ConfigContext);
    const triggerActions = disabled ? [] : trigger;
    // 菜单可见，需要将ICON旋转
    const [popupVisible, setPopupVisible] = useState(!!visible);
    const mergedVisible = 'visible' in props ? visible : popupVisible;
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const arrowCls = classNames({
        [`${prefixCls}-trigger-arrow`]: true,
        [`${prefixCls}-trigger-arrow-expand`]: mergedVisible
    });
    const titleCls = classNames({
        ['trigger-title']: true,
        ['trigger-title-withicon']: labelIcon
    });
    const child = (<div className={`${prefixCls}-trigger`}>
            {children ? children : (<>
                        {image && (typeof image === 'string')
                ? <img src={image}/>
                : image}
                        <span className={titleCls} aria-disabled={disabled}>
                            {label}
                        </span>
                        {labelIcon && <OutlinedDown className={arrowCls}/>}
                    </>)}
        </div>);
    const dropdownTrigger = cloneElement(child, {
        className: classNames(child.props.className, {
            [`${prefixCls}-trigger-disabled`]: disabled,
        }),
        disabled
    });
    const onVisibleChange = (visible) => {
        const { onVisibleChange } = props;
        setPopupVisible(visible);
        if (typeof onVisibleChange === 'function') {
            onVisibleChange(visible);
        }
    };
    const renderOverlay = () => {
        const { overlay } = props;
        let overlayNode;
        if (menu === null || menu === void 0 ? void 0 : menu.items) {
            overlayNode = <Menu {...menu}/>;
        }
        else if (typeof overlay === 'function') {
            overlayNode = overlay();
        }
        else {
            overlayNode = overlay;
        }
        overlayNode = React.Children.only(typeof overlayNode === 'string' ? <span>{overlayNode}</span> : overlayNode);
        const overlayProps = overlayNode.props;
        // menu cannot be selectable in dropdown defaultly
        // menu should be focusable in dropdown defaultly
        const { selectable = false, focusable = true } = overlayProps;
        const fixedModeOverlay = typeof overlayNode.type === 'string'
            ? overlayNode
            : cloneElement(overlayNode, {
                mode: 'vertical',
                selectable,
                focusable
            });
        return fixedModeOverlay;
    };
    return (<RcDropdown {...rest} prefixCls={prefixCls} trigger={triggerActions} onVisibleChange={onVisibleChange} visible={mergedVisible} overlay={() => renderOverlay()} getPopupContainer={getPopupContainer || getCxtPopupContainer}>
            {dropdownTrigger}
        </RcDropdown>);
};
Dropdown.Button = DropdownButton;
Dropdown.Select = Select;
Dropdown.Cascader = Cascader;
export default Dropdown;
